/** @jsx jsx */
import React from "react";
import { connectHits, Highlight } from "react-instantsearch-dom";
import { Row, Col, Skeleton } from "antd";
import { jsx, Flex, Box, Text, Link } from "theme-ui";
import HorizontalBox from "./horizontal-box";
import Action from "../Action";

const maturityBox = (maturity) => {
    let boxClass = "none";
    switch (maturity) {
        case "EXPERIMENTAL":
            boxClass = "red";
            break;
        case "BETA":
            boxClass = "orange";
            break;
        case "PRODUCTION":
            boxClass = "green";
            break;
        default:
            break;
    }
    return (<Box className={`contrib-stat ${boxClass}`} />);
};

const Hits = ({ hits }) => (
    <Flex sx={{
        flexDirection: "column", backgroundColor: "#FFFFFF", "border": "1px solid #D9D9D9"
    }}>
        {hits.length > 0 && <Row sx={{ padding: "10px", backgroundColor: "#FAFAFA", borderRight: "1px solid #F0F0F0", borderBottom: "1px solid #F0F0F0" }}>
            <Col span={9} />
            <Col span={5} type="flex" justify="center" align="middle">
                <Text sx={{ fontSize: "14px", fontWeight: "600", fontFamily: "Open Sans" }}>Experimental</Text>
            </Col>
            <Col span={5} type="flex" justify="center" align="middle">
                <Text sx={{ fontSize: "14px", fontWeight: "600", fontFamily: "Open Sans" }}>Beta</Text>
            </Col>
            <Col span={5} type="flex" justify="center" align="middle">
                <Text sx={{ fontSize: "14px", fontWeight: "600", fontFamily: "Open Sans" }}>Production</Text>
            </Col>
        </Row>}
        {hits.map((hit) =>(
            <Link
                href={`/packages/${hit.package_name.toLowerCase().split(' ').join('_')}`}
                key={hit.package_name}
            >
                <Row  sx={{ height: "50px", borderBottom: "1px solid #F0F0F0" }}>
                    <Col span={9} type="flex" justify="center" sx={{
                        paddingLeft: "24px", height: "100%", borderRight: "1px solid #F0F0F0",
                    }}>
                        <Flex sx={{ alignItems: "center", gap: "10px", height: "100%" }}>
                            {maturityBox(hit.maturity)}
                            <Text sx={{
                                wordWrap: "break-word", color: "#262626", fontWeight: 600
                            }}>
                                <Highlight attribute="package_name" hit={hit} tagName="strong" />
                            </Text>
                        </Flex>
                    </Col>
                    <Col span={5} type="flex" justify="center" align="middle" sx={{ height: "100%", borderRight: "1px solid #F0F0F0" }}>
                        <Flex sx={{ justifyContent: "center", 
                            alignItems: "center", height: "100%", gap:"8px" }}>
                            <HorizontalBox contribType="Experimental" data={hit}/>
                        </Flex>
                    </Col>
                    <Col span={5} type="flex" justify="center" align="middle" sx={{ height: "100%", borderRight: "1px solid #F0F0F0" }}>
                        <Flex sx={{ justifyContent: "center", alignItems: "center", height: "100%", gap:"8px" }}>
                            <HorizontalBox contribType="Beta" data={hit}/>
                        </Flex>
                    </Col>
                    <Col span={5} type="flex" justify="center" align="middle"
                        sx={{ height: "100%" }}>
                        <Flex sx={{ justifyContent: "center", alignItems: "center", height: "100%", gap:"8px" }}>
                            <HorizontalBox contribType="Production" data={hit}/>
                        </Flex>
                    </Col>
                </Row>
            </Link>
        ))}
        {hits.length === 0 && <Flex sx={{ alignItems:'center', justifyContent:'center', py:'10px'}}>
        <Box sx={{minWidth:['270px', 'max-content']}}>
        <Action
        label="Can't find the Expectation you need? Create an Expectation."
        url="https://docs.greatexpectations.io/docs/guides/expectations/creating_custom_expectations/overview/"
        style="secondaryV2"
        fontsize="14px"
        sx={{
          "&:hover": {
            cursor: "pointer",
          },
        }} />
        </Box>
        </Flex>}

    </Flex>
);
const CustomHits = connectHits(Hits);



class CompletenessView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
        };
    }

    componentDidMount() {
        
        this.setState({
            isLoaded: true,
        });
    }

    render() {
        const { isLoaded } = this.state;
        if (!isLoaded) {
            return (
                <Row sx={{ marginTop: "32px" }}>
                    <Skeleton paragraph={{ rows: 4 }} />
                </Row>
            );
        }
        return (
            <CustomHits />
        );
    }
}

export default CompletenessView;
